import * as ApiActions from "./ApiActions";
import * as AppActions from "./AppActions";

export default Object.assign({}, AppActions, ApiActions);
